"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COUPONS_OFFERS_SECTION_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _ApplyCouponCard = _interopRequireDefault(require("../ApplyCouponCard/ApplyCouponCard"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const COUPONS_OFFERS_SECTION_DEFAULTS = exports.COUPONS_OFFERS_SECTION_DEFAULTS = {
  title: 'Coupons & Offers',
  titleColor: '#0f0b28',
  viewAllText: 'View All',
  viewAllColor: '#686670',
  background: '#ffffff',
  fontFamily: 'Inter, sans-serif',
  paddingX: 20,
  paddingY: 12,
  headingGap: 12,
  cardGap: 12
};
const CouponsOffersSection = _ref => {
  let {
    title = COUPONS_OFFERS_SECTION_DEFAULTS.title,
    titleColor = COUPONS_OFFERS_SECTION_DEFAULTS.titleColor,
    onViewAll,
    viewAllText = COUPONS_OFFERS_SECTION_DEFAULTS.viewAllText,
    viewAllColor = COUPONS_OFFERS_SECTION_DEFAULTS.viewAllColor,
    coupons = [{}],
    children,
    background = COUPONS_OFFERS_SECTION_DEFAULTS.background,
    fontFamily = COUPONS_OFFERS_SECTION_DEFAULTS.fontFamily,
    paddingX = COUPONS_OFFERS_SECTION_DEFAULTS.paddingX,
    paddingY = COUPONS_OFFERS_SECTION_DEFAULTS.paddingY,
    headingGap = COUPONS_OFFERS_SECTION_DEFAULTS.headingGap,
    cardGap = COUPONS_OFFERS_SECTION_DEFAULTS.cardGap,
    sx = {},
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
    sx: {
      py: `${paddingY}px`,
      background: '#F2F2F3'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: `${headingGap}px`,
        px: `${paddingX}px`,
        py: `${paddingY}px`,
        background,
        width: '100%',
        boxSizing: 'border-box',
        ...sx
      },
      ...rest,
      children: [(title || onViewAll) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '12px'
        },
        children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: 1.4,
            letterSpacing: '0.25px',
            color: titleColor,
            m: 0
          },
          children: title
        }), onViewAll && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
          disableRipple: true,
          onClick: onViewAll,
          sx: {
            flexShrink: 0
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              fontFamily,
              fontWeight: 500,
              fontSize: '11px',
              lineHeight: 1.6,
              color: viewAllColor,
              textDecoration: 'underline',
              whiteSpace: 'nowrap',
              m: 0
            },
            children: viewAllText
          })
        })]
      }), children || /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: `${cardGap}px`
        },
        children: coupons.map((couponProps, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApplyCouponCard.default, {
          ...couponProps
        }, couponProps.key ?? index))
      })]
    })
  });
};
var _default = exports.default = CouponsOffersSection;